
import { definitions } from '@/types/api';
import axios from '@/axios/api';
import {
  defineComponent, reactive, ref,
} from 'vue';
import { Input, Checkbox, Button } from 'ant-design-vue';
import commonStore from '@/store/common';
import softConfigStore from '@/store/common/system';
import { useRouter } from 'vue-router';
import myButton from '@/components/Button.vue';
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';

const routerPath: {
  [index: string]: { path: string };
} = {
  admin: {
    path: '/Teacher/home',
  },
  teacher: {
    path: '/Teacher/home',
  },
  student: {
    path: '/Student/home',
  },
};

export default defineComponent({
  components: {
    aInput: Input,
    aCheckbox: Checkbox,
    aButton: Button,
    UserOutlined,
    LockOutlined,
    myButton,
  },
  setup() {
    const form = reactive({
      code: '',
      password: '',
    });
    const remember = ref(false);
    const loading = ref(false);
    const router = useRouter();
    const softConfig = softConfigStore.getState();
    const showPwd = ref(false);

    const login = async (param: definitions['LoginRequest']): Promise<definitions['LoginUserResponse']> => {
      const response = await axios.login(param);
      const { data } = response.data;
      return data as definitions['LoginUserResponse'];
    };

    const getByCode = async (code: string) => {
      const response = await axios.getByCode(code);
      const { data } = response.data;
      return data as definitions['User'];
    };

    const handleLogin = async () => {
      try {
        const LoginUserResponse = await login(form);
        commonStore.updateUserInfo(LoginUserResponse);
        const User = await getByCode(LoginUserResponse?.code || '');
        commonStore.updateUserInfo(User);
        const userData = commonStore.getState();
        if (userData && userData.role) {
          router.replace(routerPath[userData.role]);
        }
      } catch (err) {
        console.log(err);
      }
    };

    const handlePasswordClick = () => {
      showPwd.value = true;
    };

    const handleCancelClick = () => {
      showPwd.value = false;
    };

    return {
      form,
      softConfig,
      handleLogin,
      loading,
      remember,
      showPwd,
      handlePasswordClick,
      handleCancelClick,
    };
  },
});
